export var USERS_ROLES = {
    MEMBER: "member",
    ADMIN: "admin"
};
